import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountInitialState } from './account.state';
import { groupAWS, updateDashboardSettings, getPermissions } from 'store/account/account.thunk';

const initialState = AccountInitialState;

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    SET_ACCOUNT: (state, action: PayloadAction<IUserPortal>) => {
      state.account = action.payload;
    },
    SET_DB_SETTING: (state, action: PayloadAction<ISettings>) => {
      state.dashboardSettings = action.payload;
      state.hasFetchedDashboardSettings = true;
    },
    SET_INC_SETTINGS: (state, action: PayloadAction<ISettings>) => {
      state.incidentSettings = action.payload;
    },
    SET_GROUP: (state, action: PayloadAction<{ pvGroupID: number; pvGroupName: string }>) => {
      state.selectedGroup = action.payload.pvGroupID;
      state.selectedGroupName = action.payload.pvGroupName;
    },
    RESET_ACCOUNT: () => {
      return initialState;
    },
    UPDATE_DASHBOARD_SETTINGS: (state, action: PayloadAction<DashboardSettingsUpdate>) => {
      let existingSettings: DashboardSettingsUpdate = {};
      if (state?.dashboardSettings?.pvSettingValue) {
        existingSettings = JSON.parse(state.dashboardSettings.pvSettingValue);
        const updatedSettings: DashboardSettingsUpdate = {
          ...existingSettings,
          ...action.payload,
        };
        state.dashboardSettings.pvSettingValue = JSON.stringify(updatedSettings);
      } else {
        state.dashboardSettings.pvSettingValue = JSON.stringify(action.payload);
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(groupAWS.fulfilled, (state, action) => {
        state.allGroups = action.payload;
      })
      .addCase(updateDashboardSettings.fulfilled, (state, action) => {
        state.dashboardSettings = action.payload as unknown as ISettings;
      })
      .addCase(getPermissions.pending, (state) => {
        state.programsPermissions = null;
        state.error = null;
        state.isFetching = true;
      })
      // .addCase(getPermissions.fulfilled, (state, action) => {
      //   state.isFetching = false;
      //   if (action.payload === null) {
      //     state.programsPermissions = null;
      //     return;
      //   }
      //   const permissions: IPermissionsInterface[] = action.payload as IPermissionsInterface[];
      //   state.programsPermissions = Object.values(
      //     permissions.reduce(
      //       (acc, { pvServiceID, pvServiceName }) => {
      //         acc[pvServiceID] = { pvServiceID, pvServiceName }; // Overwrites duplicates with the last pvServiceName
      //         return acc;
      //       },
      //       {} as Record<number, { pvServiceID: number; pvServiceName: string }>
      //     )
      //   );
      // })
      .addCase(getPermissions.fulfilled, (state, action) => {
        state.isFetching = false;

        if (action.payload === null) {
          state.programsPermissions = null;
          return;
        }

        const permissions = action.payload as IPermissionsInterface[];

        if (!Array.isArray(permissions)) {
          state.programsPermissions = [];
          return;
        }

        const serviceMap = permissions.reduce(
          (acc, { pvServiceID, pvServiceName, pvActionName }) => {
            if (!acc[pvServiceID]) {
              acc[pvServiceID] = {
                pvServiceID,
                pvServiceName,
                appPermissions: new Set<string>(),
              };
            }
            acc[pvServiceID].appPermissions.add(pvActionName);
            return acc;
          },
          {} as Record<
            number,
            { pvServiceID: number; pvServiceName: string; appPermissions: Set<string> }
          >
        );

        state.programsPermissions = Object.values(serviceMap).map(
          ({ pvServiceID, pvServiceName, appPermissions }) => ({
            pvServiceID,
            pvServiceName,
            appPermissions: Array.from(appPermissions),
          })
        );
      })
      .addCase(getPermissions.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.error.message || 'Something went wrong!';
      });
  },
});

export default accountSlice.reducer;
